import { combineI18nMessages, defaultMessagesBG } from "@duosoftbg/bpo-components";
import validationKeysBG from "./slices/validationKey/validationKeysBG";
import { ObjectType, RegisterType } from "../../utils/constants";
import {
  CpcSearchType,
  IpcSearchType,
  PublicationSearchType,
  RepresentativeSearchType,
} from "../../types/registers/search/filter/filterTypes";

const messagesBg = combineI18nMessages(defaultMessagesBG, {
  translation: {
    "t.page.homePage": "Начало",
    "t.page.registers": "Електронни регистри",
    "t.page.marksSearch": "Търсене на марки",
    "t.page.patentsSearch": "Търсене на патенти",
    "t.page.geoIndicationsSearch": "Търсене на географски означения",
    "t.page.combinedSearch": "Комбинирано търсене",
    "t.page.agentSearch": "Търсене на представители по индустриална собственост",
    "t.page.partnershipSearch": "Търсене на съдружия/дружества",
    "t.page.partnershipView": "Преглед на съдружие/дружество",
    "t.page.agentView": "Преглед на представител",
    "t.page.decisionsSearch": "Решения",
    "t.page.europeanPatentsSearch": "Търсене на Европейски патенти",
    "t.page.utilityModelsSearch": "Търсене на полезни модели",
    "t.page.spcsSearch": "Търсене на SPC",
    "t.page.agentsSearch": "Представители по индустриална собственост",
    "t.page.plantsBreedsSearch": "Търсене на сортове и породи",
    "t.page.designsSearch": "Търсене на дизайни",
    "t.page.externalDetailView": "Преглед на обект",
    "t.page.topologySearch": "Топологии на интегрални схеми",
    "t.topologies": "Топологии",
    "t.eRegisters": "Електронни регистри",
    "t.combineSearch": "Комбинирано търсене",
    "t.modal.searchFilters.marks": "Критерии за търсене на марка",
    "t.modal.searchFilters.geoIndications": "Критерии за търсене на географско означение",
    "t.modal.searchFilters.combineSearch": "Критерии за комбинирано търсене",
    "t.modal.searchFilters.agents": "Критерии за търсене на представители",
    "t.modal.searchFilters.partnerships": "Критерии за търсене на съдружия/дружества",
    "t.modal.searchFilters.decisions": "Критерии за търсене на решения",
    "t.modal.searchFilters.instruction": "Моля изберете подходящи критерии за търсене",
    "t.modal.searchFilters.combineSearch.instruction": "Обхват на търсене",
    "t.modal.searchFilters.patents": "Критерии за търсене на патент",
    "t.modal.searchFilters.europeanPatents": "Критерии за търсене на Европейски патент",
    "t.modal.searchFilters.utilityModels": "Критерии за търсене на полезен модел",
    "t.modal.searchFilters.spcs": "Критерии за търсене на SPC",
    "t.modal.searchFilters.plantsBreeds": "Критерии за търсене на сорт/порода",
    "t.modal.searchFilters.designs": "Критерии за търсене на дизайн",
    "t.panel.mainInfo": "Информация",
    // [`t.panel.mainInfo.${VIEW_TYPES.MARK}`]: "Информация за марката",
    // [`t.panel.mainInfo.${VIEW_TYPES.GEO_INDICATION}`]: "Информация за географското означение",
    "t.panel.connectedObjects": "Други обекти на ИС",
    "t.panel.niceClasses": "Класове по Ницската класификация",
    "t.panel.viennaClasses": "Класове по Виенската класификация",
    "t.panel.persons": "Лица и контакти",
    "t.panel.priorities": "Приоритети",
    "t.panel.publications": "Публикации",
    "t.panel.history": "История на промените",
    "t.panel.partnerships": "Съдружия/Дружества",
    "t.panel.agents": "Вписани представители",
    "t.page.object": "Преглед на обект",
    "m.hideSearchCriteria": "Скрий критериите за търсене",
    "m.showSearchCriteria": "Покажи критериите за търсене",
    "m.resetFilters.success": "Изчистването приключи успешно!",
    "m.submitFilters.success": "Търсенето приключи успешно!",
    "m.alert.pleaseEnterValidSearchCriteria": "Моля въведете валидни критерии за търсене",
    "m.registers.marks.desc":
      "Електронният регистър за марки предлага възможност за търсене и преглед на национални марки",
    "m.registers.nationalPatents.desc":
      "Електронният регистър за патенти предлага възможност за търсене и преглед на национални патенти",
    "m.registers.geoIndications.desc":
      "Електронният регистър за географски означения предлага възможност за търсене и преглед на географски означения",
    "m.registers.epoPatents.desc":
      "Електронният регистър за европейски патенти предлага възможност за търсене и преглед на европейски патенти",
    "m.registers.utilityModels.desc":
      "Електронният регистър за полезни модели предлага възможност за търсене и преглед на полезни модели",
    "m.registers.plantsBreeds.desc":
      "Електронният регистър за сортове и породи предлага възможност за търсене и преглед на сортове и породи",
    "m.registers.spc.desc": "Електронният регистър за SPC предлага възможност за търсене и преглед на SPC",
    "m.registers.designs.desc": "Електронният регистър за дизайни предлага възможност за търсене и преглед на дизайни",
    "m.registers.agents.desc":
      "Електронният регистър за ПИС-ове собственост предлага възможност за търсене и преглед на ПИС-ове",
    "m.registers.associations.desc":
      "Електронният регистър за съдружия/дружества на ПИС предлага възможност за търсене и преглед на съдружия/дружества на ПИС",
    "m.registers.decisions.desc": "Електронен регистър за решения",
    "m.registers.combineSearch.desc": "Комбинирано търсене",
    "m.errorMessage.successReport": "Успешно е докладвана грешка за текущия обект",
    "l.searchFilter.name": "Наименование",
    "l.searchFilter.single.design.name": "(54) Наименование на продукта",
    "l.searchFilter.single.design.verbal.element": "Словен елемент",
    [`l.searchFilter.name.${RegisterType.DESIGN}`]: "Общо наименование на дизайните в заявката",
    [`l.searchFilter.name.${RegisterType.PATENT}`]: "(54) Наименование",
    [`l.searchFilter.name.${RegisterType.SPC}`]: "(54) Заглавие на основен патен",
    [`l.searchFilter.name.${RegisterType.MARK}`]: "(541) Наименование",
    "l.searchFilter.objectRange": "Обхват на услугата",
    // [`l.searchFilter.name.${SEARCH_FILTERS_GROUP.AGENTS}`]: "Име на представител",
    "l.searchFilter.nameExactMatch": "Наименование",
    // [`l.searchFilter.nameExactMatch.${SEARCH_FILTERS_GROUP.MARKS}`]: "Наименование на марка",
    // [`l.searchFilter.nameExactMatch.${SEARCH_FILTERS_GROUP.GEO_INDICATIONS}`]: "Наименование на географско означение",
    // [`l.searchFilter.nameExactMatch.${SEARCH_FILTERS_GROUP.PATENTS}`]: "Наименование на патент",
    // [`l.searchFilter.nameExactMatch.${SEARCH_FILTERS_GROUP.DESIGNS}`]: "Наименование на дизайн",
    "l.searchFilter.markKind": "(550) Вид марка",
    // [`l.searchFilter.markKind.${SEARCH_FILTERS_GROUP.GEO_INDICATIONS}`]: "Вид географско означение",
    "l.searchFilter.objectSubType": "Тип обект",
    [`l.searchFilter.objectSubType.${RegisterType.GEO_INDICATION}`]: "(551) Тип географско означение",
    [`l.searchFilter.objectSubType.${RegisterType.MARK}`]: "(551) Тип марка",
    "l.searchFilter.filingNumber": "Заявителски номер",
    [`l.searchFilter.filingNumber.${RegisterType.MARK}`]: "(210) Заявителски номер",
    [`l.searchFilter.filingNumber.${RegisterType.PATENT}`]: "(21) Заявителски номер",
    [`l.searchFilter.filingNumber.${RegisterType.EU_PATENT}`]: "(96) Заявителски номер",
    "l.searchFilter.filingDate": "Дата на заявяване",
    [`l.searchFilter.filingDate.${RegisterType.MARK}`]: "(220) Дата на заявяване",
    [`l.searchFilter.filingDate.${RegisterType.PATENT}`]: "(22) Дата на заявяване",
    [`l.searchFilter.filingDate.${RegisterType.EU_PATENT}`]: "(96) Дата на заявяване",
    "l.searchFilter.registrationDate": "Дата на издаване/регистрация",
    "l.searchFilter.registrationNumber": "Регистров номер",
    [`l.searchFilter.registrationNumber.${RegisterType.MARK}`]: "(111) Регистров номер",
    [`l.searchFilter.registrationNumber.${RegisterType.DESIGN}`]: "(11) Регистров номер",
    "l.searchFilter.protectedNumber": "Защитен номер",
    [`l.searchFilter.protectedNumber.${RegisterType.PATENT}`]: "(11) Защитен номер",
    "l.searchFilter.expirationDate": "Срок на закрила",
    [`l.searchFilter.expirationDate.${RegisterType.MARK}`]: "(181) Срок на закрила",
    [`l.searchFilter.expirationDate.${RegisterType.PATENT}`]: "(94) Срок на закрила",
    [`l.searchFilter.expirationDate.${RegisterType.DESIGN}`]: "(17) Срок на закрила",
    "l.searchFilter.niceClasses": "(511) Класове стоки и услуги",
    "l.searchFilter.niceClasses.specification": "Термини",
    "l.searchFilter.viennaClasses": "(531) Класове на образни елементи",
    "l.searchFilter.status": "Статус",
    "l.searchFilter.publications": "Публикации",
    [`l.searchFilter.publications.${RegisterType.MARK}`]: "(442) Публикации",
    [`l.searchFilter.publications.${RegisterType.PATENT}`]: "(41) Публикации",
    [`l.searchFilter.publications.${RegisterType.EU_PATENT}`]: "(97) Публикации",
    "l.searchFilter.publicationYear": "Година на публикация",
    "l.searchFilter.publicationNumber": "Номер на публикация",
    "l.searchFilter.publicationSection": "Раздел на публикация",
    "l.searchFilter.publicationDate": "Дата на публикация",
    "l.searchFilter.publicationSearchType": "Тип търсене",
    [`l.searchFilter.publicationSearchType.${PublicationSearchType.JOURNAL_NBR}`]: "По номер на бюлетин",
    [`l.searchFilter.publicationSearchType.${PublicationSearchType.PUBLICATION_DATE}`]: "По дата на публикация",
    "l.searchFilter.priorityDate": "Дата на приоритета",
    "l.searchFilter.country": "Държава",
    "l.searchFilter.number": "Номер",
    "l.searchFilter.representative": "Пълномощник",
    [`l.searchFilter.representative.${RegisterType.MARK}`]: "(740) Пълномощник",
    [`l.searchFilter.representative.${RegisterType.PATENT}`]: "(74) Пълномощник",
    "l.searchFilter.representativeTypeCode": "Вид пълномощник",
    "l.searchFilter.representative.code.or.name": "Наименование / Номер на ПИС(Съдружие)",
    "l.searchFilter.representative.name": "Пълномощник",
    "l.searchFilter.exactMatch": "Точно съвпадение",
    "l.searchFilter.representativeName.exactMatch": "Точно търсене",
    "l.searchFilter.representativeName.wholeWords": "Търсене по цели думи",
    "l.searchFilter.representativeName.freeSearch": "Свободно търсене",
    "l.searchFilter.viennaClasses.allSelected": "ВСИЧКИ изброени",
    "l.searchFilter.viennaClasses.withoutSelected": "БЕЗ изброените",
    "l.searchFilter.viennaClasses.someSelected": "НЯКОИ от изброените",
    "l.searchFilter.ipoArea": "Обекти на ИС",
    "l.searchFilter.decisionObjectType": "Вид обект",
    "l.searchFilter.decisionGroundType": "Правно основание",
    "l.searchFilter.decisionType": "Вид решение",
    "l.searchFilter.decisionNumber": "Номер на решение",
    "l.searchFilter.decisionDate": "Дата на решение",
    "l.table.head.partnershipName": "Име",
    "l.table.head.representativeType": "Тип",
    "l.searchFilter.agentCode": "Номер",
    "l.searchFilter.agentSpeciality": "Специалност",
    "l.searchFilter.city": "Град",
    "l.searchFilter.abstract": "Реферат",
    [`l.searchFilter.abstract.${RegisterType.PATENT}`]: "(57) Реферат",
    [`l.searchFilter.abstract.${RegisterType.UTILITY_MODEL}`]: "(57) Реферат",
    [`l.searchFilter.abstract.${RegisterType.EU_PATENT}`]: "(57) Реферат",
    [`l.searchFilter.abstract.${RegisterType.SPC}`]: "(95) Наименование на продукт",
    "l.searchFilter.origin": "Произход",
    "l.searchFilter.agentName": "Име на ПИС",
    "l.searchFilter.abstract.hint": "Търсене по много думи става с точка и запетая. Пример: влак;кола",
    "l.searchFilter.priority": "Приоритет",
    [`l.searchFilter.priority.${RegisterType.PATENT}`]: "(31, 32, 33) Приоритет",
    [`l.searchFilter.priority.${RegisterType.MARK}`]: "(310, 320, 330) Приоритет",
    "l.searchFilter.priorityDateFrom": "Дата на приоритета от",
    "l.searchFilter.priorityDateTo": "Дата на приоритета до",
    "l.searchFilter.priorityCountry": "Държава на приоритета",
    "l.searchFilter.priorityNumber": "Номер на приоритета",
    "l.searchFilter.locarnoClasses": "(51) Локарно класификация",
    "l.searchFilter.locarnoClass": "Локарно клас",
    "l.searchFilter.locarnoSubclass": "Локарно подклас",
    "l.mark": "Марка",
    "l.gi": "Географско означение",
    "l.agent": "Представител",
    "l.agent.address": "Адрес на представител",
    "l.partnership": "Съдружие/дружество",
    "l.table.head.agentName": "Име на ПИС",
    "l.table.head.agentCode": "Номер",
    "l.table.head.ipoArea": "Обекти на ИС",
    "l.table.head.agentSpeciality": "Специалност",
    "l.table.head.city": "Град",
    "l.table.head.participants": "Участници",
    "l.table.head.recordalNumber": "Входящ номер",
    "l.table.head.recordalType": "Вид вписване",
    "l.table.head.opposition.recordalType": "Вид искане",
    "l.table.head.cancellation.recordalType": "Вид искане",
    "l.table.head.opponent": "Опонент",
    "l.table.head.claimant": "Искател",
    "l.table.head.status": "Статус",
    "l.table.head.decision": "Решение",
    "l.table.head.decision.docType": "Тип документ",
    "l.table.head.decision.docNumber": "Номер на документ",
    "l.table.head.decision.docDate": "Дата на документ",
    "l.table.head.decision.link": "Линк за изтегляне",
    "l.panel.objectDecisionsData": "Решения",
    "l.table.head.recordalDate": "Дата на вписване",
    "l.table.head.recordalDate.empty": "Вписано",
    "l.table.head.invalidationDate": "Дата на заличаване",
    "l.heading.address": "Адрес",
    "l.searchFilter.patentName": "Наименование",
    "l.searchFilter.ipcClass": "(51) Класове по МПК",
    "l.searchFilter.cpcClass": "(52) Класове по КПК",
    "l.searchFilter.latinClassification": "Латинска класификация",
    "l.searchFilter.bgClassification": "БГ класификация",
    "l.searchFilter.inventor": "Изобретател",
    [`l.searchFilter.inventor.${RegisterType.PATENT}`]: "(72) Изобретател",
    "l.searchFilter.author": "Автор",
    [`l.searchFilter.author.${RegisterType.DESIGN}`]: "(72) Автор",
    // [`l.searchFilter.inventor.${SEARCH_FILTERS_GROUP.DESIGNS}`]: "Автор",
    "l.searchFilter.inventor.personSelect": "Търсене чрез избор на лице",
    "l.searchFilter.applicantOwner": "Заявител/Притежател",
    [`l.searchFilter.applicantOwner.${RegisterType.MARK}`]: "(731, 732) Заявител/Притежател",
    [`l.searchFilter.applicantOwner.${RegisterType.GEO_INDICATION}`]: "(731, 732) Заявител/Притежател",
    [`l.searchFilter.applicantOwner.${RegisterType.PATENT}`]: "(71) Заявител/Притежател",
    "l.searchFilter.applicantOwner.personSelect": "Търсене чрез избор на лице",
    "l.searchFilter.representativeTypes": "Тип пълномощник",
    "l.searchFilter.representativeSearchType": "Вид търсене по пълномощник",
    [`l.searchFilter.representativeSearchType.${RepresentativeSearchType.TEXT}`]: "Търсене по име (свободен текст)",
    [`l.searchFilter.representativeSearchType.${RepresentativeSearchType.AUTOCOMPLETE}`]:
      "Търсене чрез избор от списък",
    "l.searchFilter.representatives": "Избрани пълномощници",
    "l.patent": "Патент",
    "l.europeanPatent": "Европейски патент",
    "l.utilityModel": "Полезен модел",
    "l.spc": "SPC",
    "l.plantBreed": "Сорт/Порода",
    "l.design": "Дизайн",
    "l.table.head.decisionNumber": "Номер на решение",
    "l.table.head.decisionDate": "Дата на решение",
    "l.detail.agentName": "Наименование",
    [`l.detail.agentName.${RegisterType.AGENT}`]: "Име на представител",
    [`l.detail.agentName.${RegisterType.PARTNERSHIP}`]: "Наименование",
    "l.detail.agentType": "Тип",
    "l.detail.ipoArea": "Обекти на ИС",
    "l.detail.certification.country": "Държава на придобиване на правоспособност",
    "l.detail.origin.country": "Държава по произход",
    [`l.detail.origin.country.${RegisterType.AGENT}`]: "Гражданство",
    [`l.detail.origin.country.${RegisterType.PARTNERSHIP}`]: "Държава по произход",
    "l.detail.citizenship": "Гражданство",
    "l.detail.speciality": "Специалност",
    "l.detail.official.address": "Адрес",
    [`l.detail.official.address.${RegisterType.AGENT}`]: "Адрес на упражняване на дейността",
    [`l.detail.official.address.${RegisterType.PARTNERSHIP}`]: "Адрес на управление",
    "l.detail.ca.address": "Адрес за кореспонденция",
    "l.detail.partnershipName": "Наименование",
    "l.detail.partnershipCode": "Номер",
    "l.detail.ipoArea.short": "Обекти на ИС",
    "l.detail.partnershipType": "Тип",
    "l.detail.agentCode": "Номер",
    "l.detail.agentNameEn": "Наименование на английски",
    [`l.detail.agentNameEn.${RegisterType.AGENT}`]: "Име на представител на английски",
    [`l.detail.agentNameEn.${RegisterType.PARTNERSHIP}`]: "Наименование на английски",
    "l.detail.official.addressEn": "Адрес на английски",
    // [`l.detail.official.addressEn.${VIEW_TYPES.AGENT}`]: "Адрес на упражняване на дейността на английски",
    // [`l.detail.official.addressEn.${VIEW_TYPES.PARTNERSHIP}`]: "Адрес на управление на английски",
    "l.detail.ca.addressEn": "Адрес за кореспонденция на английски",
    "l.detail.specialityEn": "Специалност на английски",
    "l.detail.status": "Статус",
    "l.detail.partnership.participants": "Участници",
    "l.text.search.type.CONTAINS_WORDS": "Свободно съвпадение",
    "l.text.search.type.WHOLE_WORDS": "Съвпадение по цели думи",
    "l.text.search.type.EXACTLY": "Точно съвпадение",
    "l.search.operator.type.AND": "ВСИЧКИ изброени",
    "l.search.operator.type.OR": "НЯКОИ от изброените",
    "l.search.operator.type.AND_NOT": "БЕЗ изброените",
    "l.select.nice.classes.btn": "Избери класове стоки и услуги",
    "l.btn.confirm": "Потвърди",
    "l.description": "Описание",
    "l.niceClasses": "Класове стоки и услуги",
    "l.operator.search.type.AND": "Всички избрани",
    "l.operator.search.type.OR": "Някои от избраните",
    "l.operator.search.type.AND_NOT": "Без избраните",
    "l.name": "Наименование",
    "l.objectId": "Номер на заявка",
    "l.title": "Наименование",
    [`l.title.${RegisterType.DESIGN}`]: "Общо наименование",
    [`l.title.${RegisterType.SPC}`]: "Заглавие на основен патент",
    "l.filingDate": "Дата на заявяване",
    "l.agentSpeciality": "Специалност",
    "l.representativeType": "Тип",
    "l.ipoArea": "Обекти на ИС",
    "l.agentStatus": "Статус",
    "l.agentName": "Име на ПИС",
    "l.agentCode": "Номер",
    "l.btn.expand.all": "Отвори всички",
    "l.btn.collapse.all": "Затвори всички",
    "l.btn.address": "Адрес",
    "l.date.format": "дд.ММ.гггг",
    "t.history.new.record": "Вписване : ",
    "t.history.change.address": "Промяна на име и/или адрес : ",
    "t.history.renewed": "Повторно вписване : ",
    "t.history.change.active": "Промяна на вписването : ",
    "t.history.invalidated": "Отписване : ",
    "t.history.temp.invalidated": "Временно преустановяване : ",
    "l.panel.no.data": "Няма намерена информация",
    "l.panel.agentMainData": "Данни на представителя",
    "l.panel.partnershipMainData": "Данни на съдружието/дружеството",
    "l.panel.partnershipAgents": "Вписани представители",
    "l.panel.agentPartnerships": "Съдружия/Дружества, в които участва представителя",
    "l.panel.patentLikeMainData": "Основни данни",
    "l.panel.singleDesignsData": "Единични дизайни",
    "l.panel.patentLikeAbstractData": "(57) Реферат",
    "l.spcAbstractData": "(95) Наименование на продукт",
    "l.panel.plantBreedAbstractData": "Информация произхода, поддържането и размножаването",
    "l.panel.patentLikeIpcData": "(51) Класове по МПК",
    "l.panel.patentLikeCpcData": "(52) Класове по КПК",
    "l.panel.patentLikeApplicantOwnerData": "(71) Заявители/Притежатели",
    "l.panel.patentLikeInventorData": "(72) Изобретатели",
    "l.panel.designAuthorData": "(72) Автори",
    "l.panel.plantBreedAuthorData": "(72) Автори",
    "l.panel.representativeData": "(74) Пълномощници",
    [`l.panel.representativeData.${RegisterType.MARK}`]: "(740) Пълномощници",
    [`l.panel.representativeData.${RegisterType.GEO_INDICATION}`]: "(740) Пълномощници",
    "l.panel.priorityData": "Приоритети",
    [`l.panel.priorityData.${RegisterType.MARK}`]: "(310, 320, 330) Приоритети",
    [`l.panel.priorityData.${RegisterType.GEO_INDICATION}`]: "(310, 320, 330) Приоритети",
    [`l.panel.priorityData.${RegisterType.PATENT}`]: "(31, 32, 33) Приоритети",
    [`l.panel.priorityData.${RegisterType.UTILITY_MODEL}`]: "(31, 32, 33) Приоритети",
    [`l.panel.priorityData.${RegisterType.EU_PATENT}`]: "(31, 32, 33) Приоритети",
    [`l.panel.priorityData.${RegisterType.SPC}`]: "(31, 32, 33) Приоритети",
    [`l.panel.priorityData.${RegisterType.DESIGN}`]: "(31, 32, 33) Приоритети",
    "l.panel.publicationData": "(41) Публикации",
    [`l.panel.publicationData.${RegisterType.MARK}`]: "(442) Публикации",
    [`l.panel.publicationData.${RegisterType.GEO_INDICATION}`]: "(442) Публикации",
    [`l.panel.publicationData.${RegisterType.EU_PATENT}`]: "(97) Публикации",
    "l.panel.taxonData": "Латинска класификация",
    "t.page.patentsView": "Преглед на патент",
    "t.page.designsView": "Преглед на дизайн",
    "t.page.euPatentsView": "Преглед на Европейски патент",
    "t.page.plantsBreedsView": "Преглед на сорт/порода",
    "t.page.spcsView": "Преглед на SPC",
    "t.page.utilityModelsView": "Преглед на полезен модел",
    "t.page.decisionsView": "Преглед на решение",
    "l.object.title": "(54) Наименование",
    [`l.object.title.${RegisterType.SPC}`]: "(54) Заглавие на основен патент",
    [`l.object.title.${RegisterType.GEO_INDICATION}`]: "(541) Наименование",
    [`l.object.title.${RegisterType.DESIGN}`]: "Общо наименование на дизайните в заявката",
    "l.object.titleEn": "Наименование на английски",
    [`l.object.titleEn.${RegisterType.DESIGN}`]: "Общо наименование на дизайните в заявката",
    "l.object.subtype": "Подтип обект",
    "l.object.applicationNumber": "(21) Номер на заявка",
    [`l.object.applicationNumber.${RegisterType.MARK}`]: "(210) Номер на заявка",
    [`l.object.applicationNumber.${RegisterType.GEO_INDICATION}`]: "(210) Номер на заявка",
    [`l.object.applicationNumber.${RegisterType.EU_PATENT}`]: "(96) Номер на заявка",
    "l.object.filingDate": "(22) Дата на заявяване",
    [`l.object.filingDate.${RegisterType.MARK}`]: "(220) Дата на заявяване",
    [`l.object.filingDate.${RegisterType.GEO_INDICATION}`]: "(220) Дата на заявяване",
    [`l.object.filingDate.${RegisterType.EU_PATENT}`]: "(96) Дата на заявяване",
    "l.object.registrationNumber.col": "Защитен номер",
    "l.object.registrationNumber": "(11) Защитен номер",
    [`l.object.registrationNumber.${RegisterType.MARK}`]: "(111) Регистров номер",
    [`l.object.registrationNumber.${RegisterType.GEO_INDICATION}`]: "(111) Регистров номер",
    [`l.object.registrationNumber.${RegisterType.DESIGN}`]: "(11) Регистров номер",
    "l.object.registrationDate": "(24) Дата на издаване/регистрация",
    [`l.object.registrationDate.${RegisterType.MARK}`]: "(151) Дата на регистрация",
    [`l.object.registrationDate.${RegisterType.GEO_INDICATION}`]: "(151) Дата на регистрация",
    [`l.object.registrationDate.${RegisterType.DESIGN}`]: "(15) Дата на регистрация",
    "l.object.expirationDate": "(94) Срок на закрила",
    [`l.object.expirationDate.${RegisterType.MARK}`]: "(181) Срок на действие",
    [`l.object.expirationDate.${RegisterType.GEO_INDICATION}`]: "(181) Срок на действие",
    [`l.object.expirationDate.${RegisterType.DESIGN}`]: "(17) Срок на закрила",
    "l.object.mainOwner": "Заявител/притежател",
    [`l.object.mainOwner.${RegisterType.MARK}`]: "Заявител/Притежател/Ползвател",
    [`l.object.mainOwner.${RegisterType.GEO_INDICATION}`]: "Заявител/Притежател/Ползвател",
    "l.object.status": "Статус",
    "l.object.lastPaidYear": "Платено за година",
    "l.object.paymentDate": "Дата на плащане",
    "l.object.renewalFeesPaidTo": "Дата, до която са платени таксите",
    "l.object.notInForceDate": "Дата на прекратяване/заличаване",
    "l.object.viennaClasses": "Код на образни елементи",
    "l.object.locarnoClasses": "Локарно класове",
    "l.object.mark.objectSubType": "Тип марка",
    "l.person.name": "Име",
    "l.person.nationality": "Националност",
    "l.person.address": "Адрес",
    "l.priority.country": "(33) Държава",
    [`l.priority.country.${RegisterType.MARK}`]: "(330) Държава",
    [`l.priority.country.${RegisterType.GEO_INDICATION}`]: "(330) Държава",
    "l.priority.date": "(32) Дата",
    [`l.priority.date.${RegisterType.MARK}`]: "(320) Дата",
    [`l.priority.date.${RegisterType.GEO_INDICATION}`]: "(320) Дата",
    "l.priority.number": "(31) Номер",
    [`l.priority.number.${RegisterType.MARK}`]: "(310) Номер",
    [`l.priority.number.${RegisterType.GEO_INDICATION}`]: "(310) Номер",
    "l.publication.journal": "Бюлетин",
    [`l.publication.journal.${RegisterType.MARK}`]: "(442) Бюлетин",
    [`l.publication.journal.${RegisterType.GEO_INDICATION}`]: "(442) Бюлетин",
    "l.publication.date": "Дата на публикация",
    "l.publication.section": "Раздел",
    "l.taxon.taxonCode": "Таксон",
    "l.taxon.commonClassifyBg": "БГ класификация",
    "l.taxon.latinClassify": "Латинска класификация",
    [`l.application.${RegisterType.PATENT}`]: "Изобретение заявка",
    [`l.application.${RegisterType.DESIGN}`]: "Дизайн заявка",
    [`l.application.${RegisterType.EU_PATENT}`]: "Европейски патент заявка",
    [`l.application.${RegisterType.UTILITY_MODEL}`]: "Полезен модел заявка",
    [`l.application.${RegisterType.SPC}`]: "SPC заявка",
    [`l.application.${RegisterType.PLANT_BREED}`]: "Сортове растения заявка",
    "l.reference.to": "Справка към",
    "l.panel.relatedObjects": "Други обекти на ИС",
    "l.related.object.relationshipType": "Вид",
    "l.related.object.description": "Описание",
    [`l.related.object.description.${RegisterType.MARK}`]: "(646) Описание",
    "l.related.object.link": "Линк за достъп",
    "l.panel.patentLikeCitations": "Цитирания",
    "l.citation.refNbr": "Пореден номер",
    "l.citation.refClaims": "Претенции",
    "l.citation.refDescription": "Цитиран документ",
    "l.panel.patentLikeAttachmentsData": "(57) Описания и претенции",
    "l.attachment.attachmentType": "Тип документ",
    "l.attachment.fileName": "Име на файла",
    "l.attachment.download": "Линк за изтегляне",
    "l.panel.plantAttachmentsData": "Изображения",
    "l.panel.recordalData": "Вписвания",
    [`l.panel.recordalData.${RegisterType.MARK}`]: "(580) Вписвания",
    [`l.panel.recordalData.${RegisterType.GEO_INDICATION}`]: "(580) Вписвания",
    "l.panel.oppositionData": "Опозиции/Възражения",
    "l.panel.cancellationData": "Искане за отмяна/заличаване на регистрацията",
    "l.recordal.number": "Входящ номер",
    "l.recordal.type": "Вид вписване",
    "l.recordal.requestDate": "Дата на вписване",
    "l.recordal.invalidationDate": "Дата на заличаване",
    "t.page.marksView": "Преглед на марка",
    [`l.application.${RegisterType.MARK}`]: "Марка заявка",
    "l.panel.markMainData": "Информация за марката",
    "l.panel.markAttachmentsData": "Други файлове",
    "l.panel.markApplicantOwnerData": "(731, 732) Заявител/Притежател/Ползвател",
    "l.object.disclaimer": "(526) Незащитими елементи",
    "l.object.markKind": "(550) Вид",
    "l.object.markType": "(551) Тип",
    "l.object.image": "Изображение",
    "l.registrationNumber": "Регистров номер",
    "l.panel.drawingsData": "Представяне",
    [`l.panel.drawingsData.${RegisterType.MARK}`]: "(540/541/554/556) Представяне",
    [`l.panel.drawingsData.${RegisterType.GEO_INDICATION}`]: "(540/541/554/556) Представяне",
    "l.panel.coloursData": "(591) Защитени цветове",
    "l.panel.viennaClassesData": "(531) Класове на образни елементи",
    "l.panel.niceClassesData": "(511) Класове стоки и услуги",
    "l.panel.geoMainData": "Информация за географското означение",
    "t.page.geoIndicationsView": "Преглед на географско означение",
    [`l.application.${RegisterType.GEO_INDICATION}`]: "Географско означение заявка",
    "l.related.object.additional.data": "Допълнителни данни",
    "l.related.object.registration.number": "Защитен номер",
    "l.related.object.priority.date": "Дата на приоритет",
    "l.object.acquired.distinctiveness": "Доказана придобита отличителност",
    "l.yes": "Да",
    "l.no": "Не",
    "l.according.representation": "Съгласно представянето",
    "l.panel.descriptionData": "Описание",
    "l.no.declared": "Няма декларирани",
    "l.word.elements": "(541) Словни елементи",
    "l.mark.image.inid.code": "(540)",
    "l.mark.image.inid.code.AUDIO": "(556)",
    "l.mark.image.inid.code.VIDEO": "(540)",
    "l.mark.image.inid.code.IMAGE": "(540)",
    "l.markKind": "Вид",
    "l.btn.saveResultPdf": "Запази в PDF",
    "l.btn.saveResultExcel": "Запази в Excel",
    "l.btn.saveResultDocx": "Запази в Docx",
    "l.btn.saveResultFile": "Запази",
    "l.display.pdf": "Преглед в PDF",
    "l.person.related.objects": "Други обекти на ИС",
    "l.table.head.objectId": "Обект",
    "l.table.head.role": "Роля",
    "l.view.related.objects": "Виж други обекти на ИС",
    "m.warning.person.duplicates":
      "Възможно е даденото лице да съществува с различни начини на изписване на името, поради което резултатите може да са непълни.",
    "m.error.load.media": "Възникна грешка при зареждане на ресурса!",
    [`l.title.docx.${RegisterType.MARK}`]: "Справка за марка към",
    [`l.title.docx.${RegisterType.PATENT}`]: "Справка за национален патент към",
    [`l.title.docx.${RegisterType.EU_PATENT}`]: "Справка за Европейски патент към",
    [`l.title.docx.${RegisterType.GEO_INDICATION}`]: "Справка за географско означение към",
    [`l.title.docx.${RegisterType.UTILITY_MODEL}`]: "Справка за полезен модел към",
    [`l.title.docx.${RegisterType.PLANT_BREED}`]: "Справка за сорт/порода към",
    [`l.title.docx.${RegisterType.SPC}`]: "Справка за SPC към",
    [`l.title.docx.${RegisterType.DESIGN}`]: "Справка за дизайн към",
    [`l.title.docx.${RegisterType.PARTNERSHIP}`]: "Справка за съдружие/дружество към",
    [`l.title.docx.${RegisterType.AGENT}`]: "Справка за представител по ИС към",
    "l.docx.header": "Портал за електронни услуги на Патентно ведомство на Република България",
    "l.docx.page": "Страница ",
    "l.docx.of": " от ",
    "l.detail.phone": "Телефон",
    "l.detail.ca.phone": "Телефон (кореспонденция)",
    "l.detail.email": "Имейл",
    "l.detail.ca.email": "Имейл (кореспонденция)",
    "l.detail.website": "Уебсайт",
    "l.detail.ca.website": "Уебсайт (кореспонденция)",
    "l.none": "Няма",
    "l.format": "Формат",
    "l.audio": "Аудио файл",
    "l.video": "Видео файл",
    "m.warning.person.cut.results.3":
      "В таблицата са показани 200 резултата от общо {{0}}. Всички други обекти на ИС, свързани с лицето, могат да се видят при запазване на резултатите в Excel файл или чрез търсене по притежател/пълномощник в основния екран за търсене.",
    "l.single.design.identifier": "(21) Идентификатор на дизайн",
    "l.single.design.alternateKey": "(11) Регистров номер",
    "l.single.design.designType": "Под-тип",
    "l.single.design.status": "Статус",
    "l.single.design.name": "(54) Продукт(и)",
    "l.single.design.nameEn": "(54) Продукт(и) на английски",
    "l.single.design.locarno": "(51) Локарно класове",
    "l.single.design.verbal.element": "Словни елементи",
    "l.single.design.verbal.element.en": "Словни елементи на английски",
    "l.table.head.type": "Тип",
    [`l.object.${ObjectType.GEO_INDICATION}`]: "Географско означение",
    [`l.object.${ObjectType.PATENT}`]: "Патент",
    [`l.object.${ObjectType.SPC}`]: "SPC",
    [`l.object.${ObjectType.UTILITY_MODEL}`]: "Полезен модел",
    [`l.object.${ObjectType.PLANT_BREED}`]: "Сорт/Порода",
    [`l.object.${ObjectType.EU_PATENT}`]: "Европейски патент",
    [`l.object.${ObjectType.DESIGN}`]: "Дизайн",
    [`l.object.${ObjectType.MARK}`]: "Марка",
    [`l.object.${ObjectType.SINGLE_DESIGN}`]: "Единичен дизайн",
    [`l.object.${ObjectType.DIVISIONAL_MARK}`]: "Разделена марка",
    "l.main.patent.title": "Заглавие на основен патент",
    "l.product.name": "Наименование на продукт",
    "l.object.ipc": "Класове по МПК",
    "l.object.cpc": "Класове по КПК",
    "l.object.ipcCode": "Клас по МПК",
    "l.object.cpcCode": "Клас по КПК",
    "l.searchFilter.ipcSearchType": "Вид търсене по МПК",
    [`l.searchFilter.ipcSearchType.${IpcSearchType.CODE}`]: "Търсене по код (свободен текст)",
    [`l.searchFilter.ipcSearchType.${IpcSearchType.AUTOCOMPLETE}`]: "Търсене чрез избор от списък",
    "l.searchFilter.cpcSearchType": "Вид търсене по КПК",
    [`l.searchFilter.cpcSearchType.${CpcSearchType.CODE}`]: "Търсене по код (свободен текст)",
    [`l.searchFilter.cpcSearchType.${CpcSearchType.AUTOCOMPLETE}`]: "Търсене чрез избор от списък",
    "l.searchFilter.objectType": "Вид обект",
    "l.searchFilter.decisionObjectId": "Номер на заявка",
    "l.searchFilter.decisionDocumentNumber": "Номер на решение",
    "l.documentType": "Вид на решение",
    "l.documentNumber": "Номер на решение",
    "l.documentDate": "Дата на решение",
    "l.court.register":
      'Достъп до Регистъра на Административен съд София-град с възможност за търсене на решения по предмет "ЗМГО" ',
    "l.here": "тук",
    "l.missing.decision.nbrs": "Не всички решения имат номера",
    "l.decision": "Решение",
    "l.panel.decisionData": "Данни за решение",
    "l.objectType": "Вид обект",
    "l.legalGroundTypes": "Правни основания",

    "t.modal.searchFilters": "Критерии за търсене",
    "t.modal.selectTableColumns": "Избор на колони",
    "t.modal.columns.select.instruction": "Моля изберете колоните, които да се виждат в таблицата",
    "l.name.exact.match.section": "Въведете идентификатор във формат xxxxx-nnn",
    "l.exactMatch.name": "Наименование",
    "l.exactMatch.exactMatchChecked": "Точно съвпадение",
    "l.table.head.number": "№",
    "l.btn.error.report": "Докладвай грешка",
    "l.table.head.documentNumber": "Номер на документ",
    "l.table.head.applicationDate": "Дата на подаване на заявката",
    "l.table.head.expiryDate": "Срок на действие на закрила до",
    "l.table.head.representative": "Представител по ИС",
    "l.table.head.owner": "Притежател",
    "l.table.head.creator": "Създател",
    "l.table.head.file": "",
    ...validationKeysBG.translation,
  },
});

export default messagesBg;
